import { FC } from 'react';
import {
  Icon,
  Flex,
  Pill,
  Text,
  Timestamp,
  Tooltip,
  Separator,
} from '@/_components';
import type { NameCellProps } from './NameCell.types';

export const NameCell: FC<NameCellProps> = ({
  name,
  onPreview,
  isDraft,
  isTracking,
  deletedAt,
  sentDate,
  createdDate,
}) => {
  return (
    <Tooltip>
      <Tooltip.Content>
        <Flex isColumn={true} gap={6}>
          {isTracking && (
            <>
              <Text type="tiny" color="currentcolor">
                Tracking Changes
              </Text>
              <Separator isInverted={true} />
            </>
          )}
          <Text type="tiny" color="currentcolor">
            {isDraft ? (
              <>
                Created on <Timestamp timestamp={createdDate} hideTime={true} />
              </>
            ) : (
              <>
                Sent on <Timestamp timestamp={sentDate} hideTime={true} />
              </>
            )}
          </Text>
        </Flex>
      </Tooltip.Content>
      <Tooltip.Trigger>
        <Flex
          onClick={onPreview}
          isYCentered
          gap={2}
          role="button"
          aria-haspopup="dialog"
          aria-label={name}
        >
          <Text type="tiny" lineClamp={2}>
            <u>{name}</u>
          </Text>
          {deletedAt && (
            <Pill intent="danger" label="Deleted" isDark={true} size="small" />
          )}
          {isTracking && <Icon size={16} name="bell" color="secondary" />}
        </Flex>
      </Tooltip.Trigger>
    </Tooltip>
  );
};
